import { useQuery } from '@apollo/client';

import BrowseSkillsPageEntityDocumentNode from 'bundles/browse-common/queries/BrowseSkillsPageEntity.graphql';
import type {
  BrowseSkillsPageEntityQuery,
  BrowseSkillsPageEntityQueryVariables,
} from 'bundles/browse-common/queries/__generated__/BrowseSkillsPageEntity';
import { type SkillEntity } from 'bundles/browse-common/types/Skill';

type Result = {
  entity?: SkillEntity;
  loading: boolean;
};

export function useBrowseSkillsPageEntity(skillSlug: string, skip = false): Result {
  const { data, loading } = useQuery<BrowseSkillsPageEntityQuery, BrowseSkillsPageEntityQueryVariables>(
    BrowseSkillsPageEntityDocumentNode,
    {
      skip,
      variables: {
        id: skillSlug,
      },
      context: {
        clientName: 'gatewayGql',
      },
      errorPolicy: 'all',
    }
  );

  if (!data || loading) {
    return { loading: true };
  }

  const skill = data?.Skills?.multiGetSkillsById?.[0];
  const domain = skill?.domains?.[0];
  const skillPath = data?.Skills?.querySkills?.elements;
  if (skill && domain && skillPath) {
    return {
      entity: {
        domain,
        skill,
        skillPath,
      },
      loading: false,
    };
  }

  return { loading: false };
}
